module.exports = __webpack_public_path__ + "img/none.acb9ab8e.svg";